import * as React from "react"
import {render} from "react-dom"
import {ActivityLog} from "./ActivityLog/ActivityLog";
import {exportCrm} from "./Crm/exportCrm";
import {exportPrior} from "./Demand/exportPrior";
import {Final} from "./Export/Final";
import {FinanceApp} from "./Finance/FinanceApp";
import {SpecialityApp} from "./Speciality/SpecialityApp";
import {logger} from "./utils/logger";
import {FinalPrevious} from "./Export/FinalPrevious";
/*
import {opk} from "./parse/opk";

console.log(opk)
*/

/*
import {data} from "./parse/university.speciality";

console.log(data)
*/

const run = () => {
    document.getElementById("activityLog") && render(<ActivityLog/>, document.getElementById("activityLog"))

    document.addEventListener("crm:export", exportCrm)
    document.addEventListener("demand:export:prior", ({detail: {id}}: CustomEvent) => {
        exportPrior(id)
    })

    document.getElementById("exportFinal") && render(<Final/>, document.getElementById("exportFinal"))
    document.getElementById("exportFinalPrevious") && render(<FinalPrevious/>, document.getElementById("exportFinalPrevious"))
    document.getElementById("finance") && render(<FinanceApp/>, document.getElementById("finance"))
    document.getElementById("speciality") && render(<SpecialityApp/>, document.getElementById("speciality"))

//    exportPrior()
}

if (logger.enabled) {
    try {
        run()
    } catch (e) {
        logger.captureException(e)
    }
} else {
    run()
}